import { LearnerMatchingMetricsResponse } from 'services/LearnerMatchingMetricsService';

export const GET_LEARNER_MATCHING_METRICS = 'GET_LEARNER_MATCHING_METRICS';
export const GET_LEARNER_MATCHING_METRICS_SUCCESS = 'GET_LEARNER_MATCHING_METRICS_SUCCESS';
export const GET_LEARNER_MATCHING_METRICS_FAILURE = 'GET_LEARNER_MATCHING_METRICS_FAILURE';
export const DOWNLOAD_LEARNER_MATCHING_METRICS = 'DOWNLOAD_LEARNER_MATCHING_METRICS';
export const DOWNLOAD_LEARNER_MATCHING_METRICS_SUCCESS = 'DOWNLOAD_LEARNER_MATCHING_METRICS_SUCCESS';
export const DOWNLOAD_LEARNER_MATCHING_METRICS_FAILURE = 'DOWNLOAD_LEARNER_MATCHING_METRICS_FAILURE';

export interface LearnerMatchingMetricsState {
  isLoading: boolean;
  isDownloading: boolean;
  data: LearnerMatchingMetricsResponse[] | null;
  error: string | null;
}

interface GetLearnerMatchingMetricsAction {
  type: typeof GET_LEARNER_MATCHING_METRICS;
}

interface GetLearnerMatchingMetricsSuccessAction {
  type: typeof GET_LEARNER_MATCHING_METRICS_SUCCESS;
  payload: LearnerMatchingMetricsResponse[];
}

interface GetLearnerMatchingMetricsFailureAction {
  type: typeof GET_LEARNER_MATCHING_METRICS_FAILURE;
  payload: string;
}

interface DownloadLearnerMatchingMetricsAction {
  type: typeof DOWNLOAD_LEARNER_MATCHING_METRICS;
}

interface DownloadLearnerMatchingMetricsSuccessAction {
  type: typeof DOWNLOAD_LEARNER_MATCHING_METRICS_SUCCESS;
}

interface DownloadLearnerMatchingMetricsFailureAction {
  type: typeof DOWNLOAD_LEARNER_MATCHING_METRICS_FAILURE;
  payload: string;
}

export type LearnerMatchingMetricsActionTypes =
  | GetLearnerMatchingMetricsAction
  | GetLearnerMatchingMetricsSuccessAction
  | GetLearnerMatchingMetricsFailureAction
  | DownloadLearnerMatchingMetricsAction
  | DownloadLearnerMatchingMetricsSuccessAction
  | DownloadLearnerMatchingMetricsFailureAction;
